/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { css } from '@emotion/react'

import { EuiCallOut, EuiText, useEuiTheme } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { CuiRouterLink } from '@modules/cui/RouterButton'
import { useShouldShowMfaNotice } from '@modules/mfa-enforcement/lib'

import { userSettingsUrl } from '@/lib/urlBuilder'

const BackupMfaBanner: React.FunctionComponent = () => {
  const { euiTheme } = useEuiTheme()
  const userSettingPath = userSettingsUrl()
  const { shouldShowMfaNotice, onDismiss } = useShouldShowMfaNotice()

  if (!shouldShowMfaNotice) {
    return null
  }

  return (
    <EuiCallOut
      color='primary'
      iconType='info'
      size='s'
      css={css({
        '.euiCallOutHeader__title': {
          paddingInlineEnd: euiTheme.size.base,
        },
        minBlockSize: 'fit-content',
      })}
      title={
        <EuiText size='s' color='default' css={{ display: 'inline' }}>
          <FormattedMessage
            id='backup-mfa-callout'
            defaultMessage='You have only one multifactor authentication method set up. To help maintain access to
            your account, {userProfileLink}.'
            values={{
              userProfileLink: (
                <CuiRouterLink to={{ pathname: userSettingPath }}>
                  <FormattedMessage
                    id='mfa.userprofile'
                    defaultMessage='set up additional authentication methods'
                  />
                </CuiRouterLink>
              ),
            }}
          />
        </EuiText>
      }
      onDismiss={onDismiss}
    />
  )
}

export default BackupMfaBanner
